import { render, staticRenderFns } from "./CustomerIdentificationFilters.vue?vue&type=template&id=008c2fee&scoped=true"
import script from "./CustomerIdentificationFilters.vue?vue&type=script&lang=js"
export * from "./CustomerIdentificationFilters.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "008c2fee",
  null
  
)

export default component.exports